/**
 * Profile Completion Page — preserved as a backward-compatible alias.
 *
 * As of `ACT-INDEEP-FIGMA-PROFILE-QUESTIONNAIRE-DETAIL-SLICE` (Bucket B),
 * the canonical profile-completion surface is the shared Profile
 * Questionnaire mounted at `/onboarding` (CREATE mode) or
 * `/profile-questionnaire?mode=edit` (EDIT mode).
 *
 * `ProfileCompletionPage` is kept as a thin redirect so any existing
 * deep link to `/profile-completion` still reaches the canonical
 * surface without 404.
 *
 * Legacy `friend-profile` + `FriendProfileView` programs remain
 * greenfield-tested and are not removed in this ACT.
 */

import { Navigate, useLocation } from 'react-router-dom';
import { RoutePaths } from '@/routes';

export function ProfileCompletionPage() {
  const location = useLocation();
  // If the URL carries a `mode=edit` query, route the user to the
  // shared questionnaire in EDIT mode. Otherwise route to CREATE.
  const mode = new URLSearchParams(location.search).get('mode');
  const target =
    mode === 'edit'
      ? `${RoutePaths.PROFILE_QUESTIONNAIRE}?mode=edit`
      : RoutePaths.PROFILE_QUESTIONNAIRE;
  return <Navigate to={target} replace />;
}